import { MaritalStatus } from '@zorro/clients';
import { Select, type SelectProps } from '@zorro/design-system/v2/Select';
import { maritalStatusLabelConfig } from '@zorro/types';
import { ForwardedRef, forwardRef } from 'react';
import { ControllerRenderProps, Path } from 'react-hook-form';

const maritalStatusOptions = Object.values(MaritalStatus).map((status) => ({
  label: maritalStatusLabelConfig[status],
  value: status,
}));

type MaritalStatusFieldValues = {
  maritalStatus?: MaritalStatus | null;
};
type Props<T extends MaritalStatusFieldValues, U extends Path<T>> = Omit<
  ControllerRenderProps<T, U>,
  'ref'
> & { selectProps?: SelectProps };

export const MaritalStatusInput = forwardRef(
  <T extends MaritalStatusFieldValues, U extends Path<T>>(
    { selectProps, ...field }: Props<T, U>,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <Select
        {...field}
        {...selectProps}
        ref={ref}
        label="Marital status"
        placeholder="Select marital status"
        data={maritalStatusOptions}
        size="lg"
      />
    );
  }
);

MaritalStatusInput.displayName = 'MaritalStatusInput';
